import $ from 'jquery';
require('./shared/layout');

window.addEventListener("load", function () {

  // Bits-per-pixel targets for H.264 at <=30fps. Above 30fps the extra frames
  // compress well (temporal redundancy), so fps is discounted past 30 —
  // the widely used "60fps needs ~1.5x of 30fps" rule.
  var BPP = {
    low: 0.06,     // talking heads, slides, podcasts
    medium: 0.08,  // general content, IRL, variety gaming
    high: 0.11     // sports, racing, shooters, fast motion
  }

  // Compression efficiency relative to H.264
  var CODEC_FACTOR = {
    h264: 1,
    h265: 0.65,
    av1: 0.55
  }

  // Ingest caps in kbps (0 = no cap). Keep in sync with official platform docs:
  // Twitch broadcasting guidelines: max 6,000 (1080p60), help.twitch.tv
  // YouTube: max 40 Mbps (AV1/HEVC 4K60), H.264 rec 35 Mbps, support.google.com/youtube/answer/2853702
  // Kick: max 8,000, H.264 only, help.kick.com
  // Facebook Live: max recommended 15 Mbps, facebook.com/business/help/162540111070395
  var PLATFORM_CAPS = {
    none: 0,        // Livepush / any RTMP or SRT ingest
    twitch: 6000,
    youtube: 40000,
    kick: 8000,
    facebook: 15000
  }

  var RESOLUTIONS = {
    '480': [854, 480],
    '720': [1280, 720],
    '1080': [1920, 1080],
    '1440': [2560, 1440],
    '2160': [3840, 2160]
  }

  var state = {
    upload: 20,        // Mbps
    percent: 0.7,
    resolution: '1080',
    customW: 1920,
    customH: 1080,
    fps: 30,
    codec: 'h264',
    motion: 'medium',
    platform: 'none',
    audio: 128         // kbps
  }

  function bind(selector, prop, isNumber) {
    var el = $(selector)
    var handler = function () {
      state[prop] = isNumber ? Number(this.value) : this.value
      onchange()
    }
    el.on('change keyup', handler)
    // seed from markup so defaults live in one place (the HTML)
    if (el.length) state[prop] = isNumber ? Number(el.val()) : el.val()
  }

  bind('[data-brc="upload"]', 'upload', true)
  bind('[data-brc="percent"]', 'percent', true)
  bind('[data-brc="resolution"]', 'resolution', false)
  bind('[data-brc="customw"]', 'customW', true)
  bind('[data-brc="customh"]', 'customH', true)
  bind('[data-brc="fps"]', 'fps', true)
  bind('[data-brc="codec"]', 'codec', false)
  bind('[data-brc="motion"]', 'motion', false)
  bind('[data-brc="platform"]', 'platform', false)
  bind('[data-brc="audio"]', 'audio', true)

  function roundTo(value, step) {
    return Math.round(value / step) * step
  }

  function fmt(n) {
    return Math.round(n).toLocaleString('en-US')
  }

  function onchange() {
    var isCustom = state.resolution === 'custom'
    $('[data-brc-custom-row]').toggleClass('bwc-hidden', !isCustom)

    var dims = isCustom
      ? [state.customW || 0, state.customH || 0]
      : RESOLUTIONS[state.resolution]
    var w = dims[0], h = dims[1]

    // Frames past 30 cost ~half as much bitrate per frame
    var effFps = state.fps <= 30 ? state.fps : 30 + (state.fps - 30) * 0.5

    // Ideal video bitrate for this picture, in kbps
    var ideal = (w * h * effFps * BPP[state.motion] * CODEC_FACTOR[state.codec]) / 1000

    // What the connection can safely carry (video budget), in kbps
    var uploadBudget = state.upload * 1000 * state.percent - state.audio
    if (uploadBudget < 0) uploadBudget = 0

    var cap = PLATFORM_CAPS[state.platform] || 0

    var recommended = ideal
    var limiter = 'none'
    if (cap > 0 && cap < recommended) {
      recommended = cap
      limiter = 'platform'
    }
    if (uploadBudget < recommended) {
      recommended = uploadBudget
      limiter = 'connection'
    }

    recommended = Math.max(roundTo(recommended, 50), 0)
    if (recommended > 0 && recommended < 300) recommended = 300

    var maxSafe = uploadBudget
    if (cap > 0 && cap < maxSafe) maxSafe = cap
    maxSafe = Math.max(roundTo(maxSafe, 50), 0)

    var total = recommended + state.audio
    // 1.4x headroom: encoder spikes, retransmits, everything else on the network
    var neededUpload = (total * 1.4) / 1000

    $('[data-brc-result="recommended"] [data-value]').text(fmt(recommended))
    $('[data-brc-result="max"] [data-value]').text(fmt(maxSafe))
    $('[data-brc-result="total"] [data-value]').text(fmt(total))
    $('[data-brc-result="upload"] [data-value]').text(neededUpload.toFixed(1))

    // Status message
    var statusEl = $('[data-brc-status]')
    statusEl.removeClass('brc-status-ok brc-status-warn brc-status-info')
    if (recommended <= 0) {
      statusEl.addClass('brc-status-warn').text('Your upload speed is too low for this audio setting. Increase upload speed or lower audio bitrate.')
    } else if (limiter === 'connection') {
      statusEl.addClass('brc-status-warn').text('Limited by your connection. The ideal bitrate for this quality is ' + fmt(roundTo(ideal, 50)) + ' kbps — lower the resolution or fps, switch to a more efficient codec, or free up upload speed.')
    } else if (limiter === 'platform') {
      statusEl.addClass('brc-status-info').text('Capped by your platform’s ingest limit. Your connection could carry more — streaming to your own player removes this cap.')
    } else {
      statusEl.addClass('brc-status-ok').text('Your connection comfortably supports this quality with headroom to spare.')
    }

    // Cross-link into the bandwidth calculator with this bitrate prefilled
    var link = $('[data-brc-bandwidth-link]')
    if (link.length && recommended > 0) {
      link.attr('href', '/tools/bandwidth-calculator/index.html?bitrate=' + recommended)
    }
  }

  setTimeout(onchange, 0)
});
